module.exports = "<amd-internal-impact-point-seat *ngFor=\"let s of seats\" [seat]=\"s\"></amd-internal-impact-point-seat>\n"